import React from 'react';
import { Box } from '@mui/material';
import ImageBoxCard from '../../ImageBoxCard/ImageBoxCard';

const CardGrid = ({ data = [], columns = 4, rows = 2, gap = 2 }) => {
    const isCentered = data.length < columns; // 👈 center if fewer than 4 items

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: {
                    xs: '1fr',
                    sm: 'repeat(2, 1fr)',
                    md: `repeat(${Math.min(columns, data.length)}, 1fr)`,
                },
                gridAutoRows: 'minmax(250px, auto)',
                gap,
                width: '100%',
                my: 4,
                justifyContent: isCentered ? 'center' : 'flex-start',
                alignItems: isCentered ? 'center' : 'flex-start',
            }}
        >
            {data.slice(0, columns * rows).map((card, i) => (
                <ImageBoxCard
                    key={i}
                    title={card.title}
                    img={card.img}
                    href={card.href}
                    onClick={card.onClick}
                />
            ))}
        </Box>
    );
};

export default CardGrid;
